import { FeedbackApplicationStatus } from '../../api-client';

export function feedbackApplicationStatusToString(status: FeedbackApplicationStatus): string {
  return status;
}

export function stringToFeedbackApplicationStatus(
  status: string | undefined
): FeedbackApplicationStatus | undefined {
  if (!status) return undefined;
  const validStatuses = Object.values(FeedbackApplicationStatus) as string[];
  if (validStatuses.includes(status)) {
    return status as FeedbackApplicationStatus;
  }
  return undefined;
}

export function getFeedbackApplicationStatusLabel(status: FeedbackApplicationStatus): string {
  switch (status) {
    case FeedbackApplicationStatus.PENDING:
      return 'Ожидает обработки';
    case FeedbackApplicationStatus.SCHEDULED:
      return 'Запланировано';
    case FeedbackApplicationStatus.COMPLETED:
      return 'Завершено';
    case FeedbackApplicationStatus.CANCELED:
      return 'Отменено';
    default:
      return status;
  }
}
